import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { JSONPath } from 'jsonpath-plus';
import { map, Observable } from 'rxjs';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';
import { AuthenticationType } from '../models/RestApiCaller/Enums/authentication-type';

@Injectable({
    providedIn: 'root',
})
export class AutocompletionService {
    /**
     * Constructeur
     */
    constructor(private http: HttpClient) {}

    /**
     * Retourne les données correspondant à la saisie de l'utilisateur.
     * @param userInput : Saisie de l'utilisateur.
     * @returns Les données correspondant à la saisie de l'utilisateur.
     */
    getDatas(restApiConfiguration: RestApiConfiguration, userInput: string): Observable<string[]> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'text/plain');
        headers = headers.set('skipAuthentication', 'true');
        restApiConfiguration.requestConfiguration.headers.forEach((x) => {
            headers = headers.set(x.key, x.value);
        });

        switch (restApiConfiguration.requestConfiguration.authentication.authenticationType) {
            case AuthenticationType.Basic:
                const authenticationString = `${restApiConfiguration.requestConfiguration.authentication.username}:${restApiConfiguration.requestConfiguration.authentication.password}`;
                const base64EncodedAuthenticationString = Base64.encode(authenticationString);
                headers = headers.set('Authorization', `Basic ${base64EncodedAuthenticationString}`);
                break;
            case AuthenticationType.Bearer:
                headers = headers.set('Authorization', `Bearer ${restApiConfiguration.requestConfiguration.authentication.bearer}`);
                break;
            case AuthenticationType.ApiKey:
                headers = headers.set('Authorization', `X-API-KEY ${restApiConfiguration.requestConfiguration.authentication.apiKey}`);
                break;
        }

        const httpOptions = {
            headers: headers,
        };

        const url = restApiConfiguration.requestConfiguration.url.replace('{{userInput}}', userInput);

        // TODO : Gerer l'ajout de header, authentification

        // Appel de la Web Api
        let results = this.http.get<object[]>(url, httpOptions).pipe(
            map((x) => {
                console.log('Autocompletion API results :', x);
                const autocompletionDatasource = JSONPath({ path: restApiConfiguration.responseConfiguration.datasourcePath, json: x });
                console.log('Autocompletion datasource', autocompletionDatasource);
                return autocompletionDatasource as string[];
            })
        );

        return results;
    }
}
